import { create } from 'zustand'

import { AccountPaginated } from '../hooks/usePaginateAccounts'

interface SelectedAccountStore {
  account: AccountPaginated | null
  selectAccount: (user: AccountPaginated | null) => void
}

export const useSelectedAccountStore = create<SelectedAccountStore>((set) => ({
  account: null,
  selectAccount: (account) => set({ account }),
}))
